import "./Header.css";
import Anthony from "@/assets/anthony_2_cropped_more.webp";
export default function Header() {
  return (
    <header className="header flex flex-col items-center text-center mt-10">
      <div
        className="block w-36 sm:w-36 md:w-44"
        aria-label="Home"
      >
        <img
          className="w-full h-full object-contain rounded-3xl shadow-sm ring-1 ring-gray-200 transition-transform duration-300 hover:-translate-y-1 hover:rotate-1 group-hover:-translate-y-1"
          loading="lazy"
          src={Anthony}
          alt="Anthony Malkoun avatar"
        />
      </div>
      <div className="mt-4 space-y-1">
        <h1 className="uppercase font-extrabold tracking-wide text-black">
          Anthony Malkoun
        </h1>
        <h2 className="text-sm text-gray-700">Tech founder - OSS contributor - <span className="text-nowrap">AI (obligatory)</span></h2>
      </div>
    </header>
  );
}
